"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('phone-telephone', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M8.87531828,16.9438361 L13.7212999,18.3300525 C14.3558036,18.5115554 14.8599233,18.9943852 15.0686188,19.6204718 L16.7351515,24.6200697 C18.7124084,25.953403 21.0485195,26.6200697 23.7434848,26.6200697 C26.4384501,26.6200697 28.7690056,25.953403 30.7351515,24.6200697 L32.4014299,19.6212345 C32.6102661,18.9947257 33.1149126,18.5116955 33.7499583,18.3304696 L38.6122621,16.9428918 C39.3104962,16.7436336 40.061877,16.9384618 40.5753138,17.4518987 L44.0296285,20.9062133 C45.5917135,22.468314 45.5917135,25.0009669 44.0296206,26.5630598 C43.7384809,26.8541994 43.404136,27.0986433 43.038401,27.287753 C36.1633283,30.8426308 29.7316895,32.6200697 23.7434848,32.6200697 C17.7552829,32.6200697 11.3236474,30.8426325 4.44857832,27.2877581 C2.48623674,26.2731023 1.71799257,23.8597669 2.732654,21.8974283 C2.92176464,21.5316914 3.16620964,21.1973448 3.45735077,20.9062037 L6.91105709,17.4524974 C7.42481238,16.9387421 8.1767766,16.7440149 8.87531828,16.9438361 Z",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    fill: props.outFillColor,
    fillRule: "nonzero",
    strokeLinejoin: props.strokeLinejoin,
    transform: "translate(23.743067, 24.743067) rotate(45.000000) translate(-23.743067, -24.743067) "
  }))));
});

exports.default = _default;